export var FeatureValueType;
(function (FeatureValueType) {
    FeatureValueType["Boolean"] = "BOOLEAN";
    FeatureValueType["String"] = "STRING";
    FeatureValueType["Number"] = "NUMBER";
    FeatureValueType["Json"] = "JSON";
})(FeatureValueType || (FeatureValueType = {}));
//# sourceMappingURL=feature-value-type.js.map